import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, styled } from '@mui/material';
import { Publish as UploadIcon } from '@mui/icons-material';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    '& .upload-button': {
        width: '100%',
    },
}));
const UploadFileContainer = ({ children, label, accept, handleUpload, handleUploads }) => {
    const handleFileChange = (fileList) => {
        if (fileList) {
            if (handleUploads) {
                const files = [];
                [...fileList].forEach((file) => {
                    let fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    fileReader.onload = (event) => {
                        files.push(event.target.result);
                        if (files.length === fileList.length) {
                            handleUploads(files);
                        }
                    };
                });
            }
            else if (handleUpload) {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(fileList[0]);
                fileReader.onload = (event) => {
                    handleUpload(event.target.result);
                };
            }
        }
    };
    return (_jsxs(Root, { children: [_jsx("input", Object.assign({ accept: accept, id: "upload-file", "data-qa": "upload-file-input", type: "file", style: { display: 'none' }, onChange: (event) => handleFileChange(event.target.files) }, (!!handleUploads
                ? {
                    multiple: true,
                }
                : {}))), _jsx("label", Object.assign({ htmlFor: "upload-file" }, { children: _jsx(Button, Object.assign({ className: "upload-button", variant: "outlined", color: "primary", "data-qa": "upload-file-button", onClick: (event) => event.currentTarget.parentElement.click(), startIcon: _jsx(UploadIcon, {}) }, { children: label })) })), children] }));
};
export default UploadFileContainer;
//# sourceMappingURL=index.js.map